import { Alert, Paper } from "@mui/material";

const InitSearchAlert = () => {
  return (
    <Paper
      elevation={0}
      sx={{ borderRadius: "25px", padding: "24px 28px 24px 24px" }}
    >
      <Alert severity="info">
        Please enter your Zip code to find nearest location.
      </Alert>
    </Paper>
  );
};

export default InitSearchAlert;
